/*
 * Fix for stripe.js feature detection and iframe injection
 *
 * webcomponents.js polyfill causes the stripe.js feature
 * detection to break and therefore attempts to create an iframe using
 * the old tag based syntax. We'll catch that here, and handle the creation
 * in a compatible way.
 *
 */
const IFRAME_REGEX = /^<iframe/;
const container = document.createElement(`div`);
const docCreateElement = document.createElement;
document.createElement = function(tag) {
  if (IFRAME_REGEX.test(tag)) {
    container.innerHTML = tag;
    return container.firstChild;
  } else {
    return docCreateElement.apply(document, arguments);
  }
};



// WEBPACK FOOTER //
// ./js/stripe-patch.js